export default "__VITE_ASSET__LyTAra5d__"